

export function useTabOverrun() {
  const params = new URLSearchParams(window.location.search);
  const tab = params.get('tab-overrun');
  return tab !== "0";
}

export default useTabOverrun;
